import React from "react";
import "./payment-section-info.component.scoped.scss";
import { useTranslation } from "react-i18next";

export const PaymentSectionInfoComponent = (props: any) => {
  const [t] = useTranslation();

  return (
    <div className="payment-section-info">
      <div className="icon">
        <img src="/icons/payment.svg" alt=""/>
      </div>
      <div>
        <div className="title">{t(props.title)}</div>
        <div className="sub-title">{t(props.subTitle)}</div>
      </div>
      {props.children}
    </div>
  );
};
